"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Raven = _interopRequireDefault(require("Raven"));

var _loggers = require("customer-data-tracking/loggers");

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _classnames = _interopRequireDefault(require("classnames"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _PlaybooksActions = require("crm_data/playbooks/actions/PlaybooksActions");

var _ObjectsActions = _interopRequireDefault(require("crm_data/objects/ObjectsActions"));

var _PlaybooksStore = _interopRequireDefault(require("crm_data/playbooks/stores/PlaybooksStore"));

var _ActivityTypesStore = _interopRequireDefault(require("crm_data/activityTypes/ActivityTypesStore"));

var _PortalStore = _interopRequireDefault(require("crm_data/portal/PortalStore"));

var _UserStore = _interopRequireDefault(require("crm_data/user/UserStore"));

var _CurrencyCodeDependency = _interopRequireDefault(require("crm_ui/components/formatting/CurrencyCodeDependency"));

var _DefaultPlaybookAssociationIdsDependency = _interopRequireDefault(require("crm_data/playbooks/dependencies/DefaultPlaybookAssociationIdsDependency"));

var _HasActivityTypesDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/HasActivityTypesDependency"));

var _PlaybookAssociationsDependency = _interopRequireDefault(require("crm_data/playbooks/dependencies/PlaybookAssociationsDependency"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _CallOutcomeDispositions = require("crm_data/constants/CallOutcomeDispositions");

var _createPlaybooksAssociations = _interopRequireDefault(require("crm_ui/profile/sidebar/playbooks/utils/createPlaybooksAssociations"));

var _createPlaybookInteractionRecord = _interopRequireDefault(require("crm_ui/profile/sidebar/playbooks/utils/createPlaybookInteractionRecord"));

var _EngagementMediator = require("crm_ui/components/profile/interactions/common/EngagementMediator");

var _PlaybooksAPI = require("crm_data/playbooks/api/PlaybooksAPI");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogButton"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _PlaybookCardBody = _interopRequireDefault(require("playbooks-modal/components/PlaybookCardBody"));

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    max-height: calc(100vh - 137px);\n    margin-left: 5px;\n    width: ", ";\n    overflow: ", ";\n    margin-bottom: 0;\n    box-shadow: 0 1px 24px 0 rgba(0, 0, 0, 0.08);\n\n    .playbooks-overlay-body {\n      flex-grow: 1;\n      overflow: auto;\n      height: ", ";\n      min-height: ", ";\n      padding: ", ";\n\n      .playbooks-modal-body {\n        padding: 16px 0;\n      }\n    }\n\n    .playbooks-overlay-footer {\n      border-top: 1px solid ", ";\n      height: ", ";\n      min-height: ", ";\n      padding: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var dependencies = {
  user: _UserStore.default,
  portal: _PortalStore.default,
  subject: _SubjectDependency.default,
  defaultCurrencyCode: _CurrencyCodeDependency.default,
  defaultAssociationIds: _DefaultPlaybookAssociationIdsDependency.default,
  associations: _PlaybookAssociationsDependency.default,
  playbooks: {
    stores: [_PlaybooksStore.default],
    deref: function deref() {
      return _PlaybooksStore.default.get('searchData');
    }
  },
  selectedPlaybookId: {
    stores: [_PlaybooksStore.default],
    deref: function deref() {
      return _PlaybooksStore.default.get('selectedPlaybookId');
    }
  },
  hasActivityTypes: _HasActivityTypesDependency.default,
  activityTypeOptions: {
    stores: [_ActivityTypesStore.default],
    deref: function deref() {
      if (!_ScopesContainer.default.isScoped('crm-activity-types')) {
        return [];
      }

      var activityTypes = _ActivityTypesStore.default.get();

      if (!activityTypes) {
        return [];
      }

      return activityTypes.reduce(function (acc, type) {
        var optionName = type.get('name');
        acc.push({
          text: optionName,
          value: optionName
        });
        return acc;
      }, []);
    }
  }
};
var PlaybooksOverlay = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "PlaybookCardWrapper__PlaybooksOverlay",
  componentId: "sc-1072t4s-0"
})(_templateObject(), function (_ref) {
  var isMinimized = _ref.isMinimized;
  return isMinimized ? '300px' : '580px';
}, function (_ref2) {
  var isMinimized = _ref2.isMinimized;
  return isMinimized ? 'hidden' : 'auto';
}, function (_ref3) {
  var isMinimized = _ref3.isMinimized;
  return isMinimized ? '0' : '100%';
}, function (_ref4) {
  var isMinimized = _ref4.isMinimized;
  return isMinimized ? '0' : 'auto';
}, function (_ref5) {
  var isMinimized = _ref5.isMinimized;
  return isMinimized ? '0' : '10px';
}, _colors.KOALA, function (_ref6) {
  var isMinimized = _ref6.isMinimized;
  return isMinimized ? '0' : 'auto';
}, function (_ref7) {
  var isMinimized = _ref7.isMinimized;
  return isMinimized ? '0' : '60px';
}, function (_ref8) {
  var isMinimized = _ref8.isMinimized;
  return isMinimized ? '0 !important' : 'auto';
});

var PlaybookCardWrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PlaybookCardWrapper, _PureComponent);

  function PlaybookCardWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PlaybookCardWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PlaybookCardWrapper).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(PlaybookCardWrapper, [{
    key: "handleToggleMinimize",
    value: function handleToggleMinimize() {
      if (this.props.isMinimized) {
        (0, _PlaybooksActions.maximizePlaybook)();
      } else {
        (0, _PlaybooksActions.minimizePlaybook)();
      }
    }
  }, {
    key: "handleObjectPropertyChanged",
    value: function handleObjectPropertyChanged(_ref9) {
      var objectType = _ref9.objectType,
          objectId = _ref9.objectId,
          propertyName = _ref9.propertyName,
          value = _ref9.value;
      var _this$props = this.props,
          subject = _this$props.subject,
          associations = _this$props.associations,
          currentObjectType = _this$props.objectType;
      var object = objectType === currentObjectType ? subject : associations.getIn([objectType, objectId]);

      if (!object) {
        (0, _Alerts.addError)('ObjectsActions.alerts.alertUpdatePropertiesError');
        return;
      }

      _ObjectsActions.default.updateStores(object, (0, _immutable.Map)((0, _defineProperty2.default)({}, propertyName, value)), {
        onError: function onError() {
          return (0, _Alerts.addError)('ObjectsActions.alerts.alertUpdatePropertiesError');
        }
      });
    }
  }, {
    key: "handleSaveContent",
    value: function handleSaveContent(html, _ref10) {
      var submissionId = _ref10.submissionId,
          type = _ref10.type,
          selectedDisposition = _ref10.selectedDisposition,
          selectedActivityType = _ref10.selectedActivityType;
      var _this$props2 = this.props,
          associations = _this$props2.associations,
          subject = _this$props2.subject,
          subjectId = _this$props2.subjectId,
          objectType = _this$props2.objectType;
      var engagementAssociations = (0, _createPlaybooksAssociations.default)({
        subjectId: subjectId,
        objectType: objectType,
        associations: associations
      });
      var interactionRecord = (0, _createPlaybookInteractionRecord.default)({
        subject: subject,
        objectType: objectType,
        html: html,
        selectedDisposition: selectedDisposition,
        selectedActivityType: selectedActivityType,
        type: type
      });
      var engagementRecord = (0, _EngagementRecord.default)(interactionRecord.toMap()).set('associations', engagementAssociations);
      (0, _EngagementMediator.createEngagement)(engagementRecord, objectType, interactionRecord).then(function (_ref11) {
        var engagement = _ref11.engagement;

        if (submissionId) {
          (0, _PlaybooksAPI.setPlaybookAssociation)({
            submissionId: submissionId,
            engagementId: engagement.get('id'),
            engagementType: engagement.get('type')
          }).catch(function (error) {
            _Raven.default.captureMessage('[playbooks] Error setting an association', {
              extra: {
                error: error
              }
            });
          });
        }

        _loggers.CrmLogger.log('playbookInteraction', {
          action: 'playbooks logged note',
          engagementType: type,
          activityType: selectedActivityType || undefined,
          callDisposition: selectedDisposition || undefined
        });
      });
      (0, _PlaybooksActions.closePlaybook)();
      this.objectPropertyUpdates = (0, _immutable.Map)();
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props3 = this.props,
          subject = _this$props3.subject,
          subjectId = _this$props3.subjectId,
          user = _this$props3.user,
          portal = _this$props3.portal,
          objectType = _this$props3.objectType,
          activityTypeOptions = _this$props3.activityTypeOptions,
          hasActivityTypes = _this$props3.hasActivityTypes,
          associations = _this$props3.associations,
          selectedPlaybookId = _this$props3.selectedPlaybookId,
          defaultAssociationIds = _this$props3.defaultAssociationIds,
          defaultCurrencyCode = _this$props3.defaultCurrencyCode;

      if (!selectedPlaybookId) {
        return null;
      }

      return _react.default.createElement(_PlaybookCardBody.default, {
        currencyCode: defaultCurrencyCode,
        playbookId: selectedPlaybookId,
        getAuth: function getAuth() {
          return {
            user: (0, _immutable.fromJS)(user),
            portal: (0, _immutable.fromJS)(portal),
            gates: (0, _immutable.List)(portal.enabled_gates)
          };
        },
        insertContent: true,
        source: objectType,
        sourceId: subjectId,
        sourceObject: subject,
        associationIds: defaultAssociationIds,
        associations: associations,
        requestAssociations: _PlaybooksActions.requestAssociations,
        hasActivityTypes: hasActivityTypes,
        activityTypeOptions: activityTypeOptions,
        callDispositions: (0, _CallOutcomeDispositions.getAllCallDispositions)(),
        onConfirm: this.handleSaveContent,
        onReject: _PlaybooksActions.closePlaybook,
        onObjectPropertyChanged: this.handleObjectPropertyChanged
      });
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      return _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Minimize dialog",
        className: "m-x-2",
        onClick: _PlaybooksActions.closePlaybook,
        iconName: "remove"
      });
    }
  }, {
    key: "renderMinimizeToggle",
    value: function renderMinimizeToggle() {
      return _react.default.createElement(_UIDialogButton.default, {
        "aria-label": "Minimize dialog",
        className: "m-x-2",
        onClick: this.handleToggleMinimize,
        iconName: "minus"
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      return _react.default.createElement(_UIColumn.default, null, this.renderMinimizeToggle(), this.renderCloseButton());
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      return _react.default.createElement(_UIColumnSpreads.default, null, _react.default.createElement("div", {
        onClick: this.handleToggleMinimize,
        className: "pointer"
      }, _react.default.createElement("h5", {
        className: "m-all-0 p-all-0"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "profileSidebarModule.playbooksModule.modal.title"
      }))));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return _react.default.createElement(_UIDialogHeader.default, {
        className: (0, _classnames.default)('communicator-header', 'p-x-5')
      }, _react.default.createElement(_UIColumnWrapper.default, {
        align: "center"
      }, this.renderTitle(), this.renderActions()));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(PlaybooksOverlay, {
        className: "flex-shrink-0 p-x-0 p-bottom-0",
        isMinimized: this.props.isMinimized
      }, this.renderHeader(), this.renderBody());
    }
  }]);
  return PlaybookCardWrapper;
}(_PureComponent2.default);

PlaybookCardWrapper.propTypes = {
  activityTypeOptions: _propTypes.default.array.isRequired,
  associations: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  defaultCurrencyCode: _propTypes.default.string.isRequired,
  defaultAssociationIds: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  hasActivityTypes: _propTypes.default.bool.isRequired,
  isMinimized: _propTypes.default.bool.isRequired,
  objectType: _ProfileObjectTypesType.default.isRequired,
  portal: _propTypes.default.object,
  selectedPlaybookId: _propTypes.default.string.isRequired,
  subject: _SubjectType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  user: _propTypes.default.object.isRequired
};

var _default = (0, _generalStore.connect)(dependencies)(PlaybookCardWrapper);

exports.default = _default;
module.exports = exports.default;